/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

export interface RouteOrderAck {
  id?: number;
  origId?: number;
  sendToLpTimestamp?: string;
  lpAckTimestamp?: string;
  fullyProcessedTimestamp?: string;
  pairId?: number;
  pair?: Pair;
  executedQuantity?: number;
  executedPrice?: number;
  executedVolume?: number;
  comment?: string;
  canceled?: boolean;
}
